import { FileService, MessageService } from '@philips-emr/tws-core/lib/services';
import { HttpMethod } from '@philips-emr/tws-core/lib/services/http-service';

import { Endpoint } from '../constants';

import { ToastServiceProviderAccreditation } from './toast-service';

enum ieTabela {
  CALL = 'calls',
  PROVIDER_ACCREDITATION = 'provider_accreditation',
  DOCUMENT_ORIENTATION_MANUAL = 'document-orientation-manual',
  FILE_TEMPLATES_DOCUMENTS = 'pls_param_cred_prestador',
  PROVIDER_ACCREDITATION_GUIDANCE_MANUAL = 'guidance-manual',
}

class ProviderAccreditationFileService {
  public static download(nrSeqUser: number, nmTable: ieTabela, nrSeqAttachment: number, name?: string): void {
    ToastServiceProviderAccreditation.informationBubble(MessageService.translate('pa.download-initiated'));
    FileService.download(Endpoint.GET.DOWNLOAD, name, { nrSeqUser, nmTable, nrSeqAttachment }, HttpMethod.GET)
      .catch(() => {
        ToastServiceProviderAccreditation.close();
        ToastServiceProviderAccreditation.error(MessageService.translate('pa.not-possible-locate-file'));
      });
  }

  public static preview(path: string): void {
    FileService.preview(path);
  }

}

export {
  ProviderAccreditationFileService,
  ieTabela,
};
